module.exports = __webpack_public_path__ + "img/Admin.ee7f9c35.svg";